export default "__VITE_ASSET__CggkrB7E__"